import { render } from "./PersonalInfoTab.vue?vue&type=template&id=06cd370a"
import script from "./PersonalInfoTab.vue?vue&type=script&lang=js"
export * from "./PersonalInfoTab.vue?vue&type=script&lang=js"

import "./PersonalInfoTab.vue?vue&type=style&index=0&id=06cd370a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__